export const version = 'kunde-v1.20.0-SNAPSHOT-f1de7f474e4da113cf0d06d89e7277a39c8079fd';